import React from 'react';
import { passwordStrength } from '../lib/passwordStrength';

// Live strength hint shown under a password field on signup / reset.
export const PasswordStrengthMeter = ({ value, testid = 'password-strength' }) => {
  const { score, label, colorClass, percent } = passwordStrength(value);
  if (!value) return null;
  return (
    <div className="mt-1.5" data-testid={testid}>
      <div className="flex gap-1" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${i < score ? colorClass : 'bg-border'}`}
          />
        ))}
      </div>
      <p className="mt-1 text-xs text-muted-foreground" data-testid={`${testid}-label`}>
        Password strength: <span className="font-medium text-foreground">{label}</span>
        {score < 2 && <span> — use 8+ characters with a mix of letters, numbers & symbols.</span>}
      </p>
      <span className="sr-only">Strength {percent}%</span>
    </div>
  );
};

export default PasswordStrengthMeter;
